import {
  makeAuthenticatedRequest,
  makeAuthenticatedRequestForFile,
} from "./api";
import { s3 } from "./s3";

export const getAllClassrooms = async (props) => {
  try {
    const {
      search = "",
      status = "",
      startDateTime = "",
      endDateTime = "",
      pageNumber,
      pageSize,
      isLiveClassDropDown,
    } = props;
    const URL = `/classrooms/?search=${search}&status=${status}&startDateTime=${startDateTime}&endDateTime=${endDateTime}&pageNumber=${pageNumber}&pageSize=${pageSize}${isLiveClassDropDown ? `&isLiveClassDropDown=${isLiveClassDropDown}` : ''}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getPublicClassrooms = async () => {
  try {
    const URL = `/classrooms_public?showAll=true`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getClassroomData = async () => {
  try {
    const URL = `/classrooms/getData`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getClassroomByUserId = async (userId) => {
  try {
    const URL = `/classrooms/enrolled?userId=${userId}&pageNumber=0&pageSize=10`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getSingalClassroomData = async (id) => {
  try {
    const URL = `/classrooms/${id}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Dynamically add "Review Attempts" module if classroom has IELTS exams
        if (
          data?.classRoom?.hasIeltsExams &&
          data?.classRoom?.modulesIncluded &&
          !data.classRoom.modulesIncluded.includes("Review Attempts")
        ) {
          data.classRoom.modulesIncluded = [
            ...data.classRoom.modulesIncluded,
            "Review Attempts",
          ];
        }
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getLiveClassesOfClassroom = async ({
  classroomId,
  startDate = "",
  endDate = "",
  page = 0,
  pageSize = 40,
}) => {
  try {
    const URL = `/liveClasses/classroom/${classroomId}?startDateTime=${startDate}&endDateTime=${endDate}&pageNumber=${page}&pageSize=${pageSize}&status=Upcoming`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getAllLiveClassesOfClassroom = async ({ classroomId }) => {
  try {
    const URL = `/liveClasses/classroom/${classroomId}?status=Live`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const deleteSingleClassroom = async (classroomId) => {
  try {
    return await makeAuthenticatedRequest(
      `/classrooms/${classroomId}`,
      "DELETE",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Delete classroom:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete classroom:", error);
    return { ok: false, error: error };
  }
};

export const cloneClassroom = async (classroomId) => {
  try {
    return await makeAuthenticatedRequest(
      `/classrooms/duplicate/${classroomId}`,
      "POST",
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Delete classroom:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete classroom:", error);
    return { ok: false, error: error };
  }
};

export const createClassroom = async (payload) => {
  try {
    return await makeAuthenticatedRequestForFile(
      `/classrooms/`,
      "POST",
      payload,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return response.text().then((text) => {
            return { ok: false, error: text };
          });
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create classroom:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete classroom:", error);
    return { ok: false, error: error };
  }
};

export const updateClassroom = async (id, payload) => {
  try {
    return await makeAuthenticatedRequestForFile(
      `/classrooms/${id}`,
      "PATCH",
      payload,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create classroom:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete classroom:", error);
    return { ok: false, error: error };
  }
};

export const getRecordingsOfClassroom = async (classroomId) => {
  try {
    const URL = `/liveClasses/recordings/${classroomId}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getRecordingsOfMeeting = async (meetingID) => {
  try {
    const URL = `/liveClasses/recordingsOfMeeting/${meetingID}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getConceptVideosOfSubject = async (
  classroomId,
  courseId,
  subjectId,
) => {
  try {
    const URL = `/classrooms/videos/${classroomId}/${courseId}/${subjectId}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getLectureNotesOfSubject = async (
  classroomId,
  courseId,
  subjectId,
) => {
  try {
    const URL = `/classrooms/notes/${classroomId}/${courseId}/${subjectId}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getPracticesOfSubject = async (
  classroomId,
  courseId,
  subjectId,
) => {
  try {
    const URL = `/classrooms/practices/${classroomId}/${courseId}/${subjectId}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const getTestsOfSubject = async (classroomId, courseId, subjectId) => {
  try {
    const URL = `/classrooms/tests/${classroomId}/${courseId}/${subjectId}`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const updateVideoMaterialProgress = async (
  topicId,
  videoId,
  payload,
) => {
  try {
    return await makeAuthenticatedRequest(
      `/materials/${topicId}/videos/${videoId}`,
      "PATCH",
      payload,
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create classroom:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete classroom:", error);
    return { ok: false, error: error };
  }
};

export const uploadToS3 = async (fileData) => {
  if (!fileData) {
    return null;
  }
  try {
    const s3Key = `${Date.now()}_${fileData.name}`;
    const params = {
      Bucket: process.env.REACT_APP_S3_DISCUSSION_BUCKET_NAME,
      Key: s3Key,
      Body: fileData,
      ContentType: fileData.type,
    };

    const uploadResponse = await s3
      .upload(params, {
        partSize: 20 * 1024 * 1024,
        queueSize: 5,
      })
      .on("httpUploadProgress", () => {
        // const percentage = Math.round((progress.loaded / progress.total) * 100);
        // console.log(percentage);
      })
      .promise();

    return uploadResponse.Location;
  } catch (error) {
    console.error("Error uploading/updating file:", error);
    throw error;
  }
};
